/**
 * @file activityLabels.js
 * @description Display-only label mapping for activity names (COL-140).
 *
 * IMPORTANT: These are presentation labels ONLY. The stored/canonical
 * activity value (in oa.task.activity_name and used for filtering,
 * dropdown values, and intake matching) is NOT changed — only what the
 * user sees in grids, detail views, and reports.
 */

const ACTIVITY_LABELS = {
    "Face Page and Claims": "FP & Claims",
    "Face Page, Claims and Drawings": "FP, Claims & Drawings",
    // Legacy/variant spelling (singular "Drawing") emitted by some intake controls
    "Face Page, Claims and Drawing": "FP, Claims & Drawings",
    // "Front Page" variants — the wording actually produced by Excel intake
    // (the tickets say "Face Page"; stored data uses "Front Page"). Both
    // abbreviate to the same FP label.
    "Front Page & Claims": "FP & Claims",
    "Front Page and Claims": "FP & Claims",
    "Front Page, Claims & Drawings": "FP, Claims & Drawings",
    "Front Page, Claims and Drawings": "FP, Claims & Drawings",
    "Front Page, Claims & Drawing": "FP, Claims & Drawings",
    "Front Page, Claims and Drawing": "FP, Claims & Drawings"
};

/**
 * Map a stored activity name to its display label. Unknown values pass
 * through unchanged.
 * @param {string} activityName
 * @returns {string}
 */
export const formatActivityLabel = (activityName) => {
    if (!activityName) return activityName || "";
    return ACTIVITY_LABELS[activityName] || activityName;
};

export { ACTIVITY_LABELS };
